import { createApp } from "vue";
import { Quasar } from "quasar";
import "@quasar/extras/material-icons/material-icons.css";
import "quasar/src/css/index.sass";
import App from "./App.vue";
import "./styles.css";

function mountApp() {
  createApp(App).use(Quasar, {
    config: {
      brand: {
        primary: "#21d8f3",
        secondary: "#8ba4b8",
        accent: "#1ee5be",
        positive: "#2fe58a",
        negative: "#ff4c48",
        warning: "#ffc857",
        info: "#2f8cff"
      }
    }
  }).mount("#root");
}

// Dev-only preview: `?demo=1` bypasses login and mocks the API with sample data.
if (import.meta.env.DEV && new URLSearchParams(window.location.search).has("demo")) {
  import("./dev-demo.js")
    .then(({ installDemoMode }) => installDemoMode())
    .finally(mountApp);
} else {
  mountApp();
}
